import React, { useContext, useState } from 'react';
import { Input } from '../../../ui/Inputs';
import { useTranslation } from 'react-i18next';
import { useEditCRMUrlMutation } from '../../../../store/api';

import { CRMInputProps } from './types';
import { AuthContext } from '../../../../context/Auth/AuthContext';
import { Roles } from '../../../../constants';
import styles from './CRMModal.module.scss';
import { CheckIcon, LinkIcon, SaveIcon } from '../../../ui/Icons';
import { Button } from '../../../ui/Buttons';

const CRMInput: React.FC<CRMInputProps> = ({ project_id, url }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const isManager = user?.role === Roles.MANAGER;

  const [editCRMUrl, { isLoading: isEditing }] = useEditCRMUrlMutation();
  const [crmUrl, setCrmUrl] = useState(url ?? '');

  const trimmedUrl = crmUrl?.trim();
  const isSaved = !!url && trimmedUrl === url;
  const isDirty = !!trimmedUrl && trimmedUrl !== url;

  const validUrl = trimmedUrl.startsWith('http') ? trimmedUrl : `https://${trimmedUrl}`;

  const handleChangeCRMUrl = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCrmUrl(value);
  };

  const handleSaveCRMUrl = () => {
    if (!isDirty || isEditing) return;
    editCRMUrl({ ID: project_id, crm_url: trimmedUrl });
  };

  return (
    <div className={styles.crmInputWrapper}>
      <div className={styles.crmInputContainer}>
        <Input
          name="crm-url"
          value={crmUrl}
          onChange={handleChangeCRMUrl}
          placeholder={`${t(isManager ? 'emptyCRMUrl' : 'enterCRMUrl')}`}
          disabled={isManager}
          inputClassName={styles.crmInput}
        />

        <div className={styles.crmInputOptions}>
          {isSaved && (
            <div className={styles.checkIcon}>
              <CheckIcon />
            </div>
          )}
          {validUrl && (
            <a href={validUrl} target="_blank" rel="noopener noreferrer" className={styles.crmLink}>
              <LinkIcon />
            </a>
          )}
        </div>
      </div>
      <Button
        onClick={handleSaveCRMUrl}
        className={styles.saveBtn}
        disabled={!isDirty || isEditing}
        aria-busy={isEditing}
      >
        <SaveIcon />
      </Button>
    </div>
  );
};

export default CRMInput;
